import { render } from "./Confirm.vue?vue&type=template&id=35f427eb"
import script from "./Confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Passwords/Confirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35f427eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35f427eb', __exports__)) {
    api.reload('35f427eb', __exports__)
  }
  
  module.hot.accept("./Confirm.vue?vue&type=template&id=35f427eb", () => {
    api.rerender('35f427eb', render)
  })

}


export default __exports__